import React, { useState, useEffect, useContext } from "react";
import Application from "../../../StateContext/Application";
import { use } from "react";
import { apiurl } from "../../../../../path";

const BillFiles = (props) => {
  const statecalls = useContext(Application);
  const { GetBillFiles } = statecalls;
  const [refundfiles, setRefundFiles] = useState([]);
  const [refunddata, setRefundData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  useEffect(() => {
    GetAllBillFiles();
  }, [])

  const totalPages = Math.ceil(refundfiles.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = refundfiles.slice(indexOfFirstBill, indexOfLastBill);

  async function GetAllBillFiles() {
    try {
      let data = await GetBillFiles();
      setRefundFiles(data);
    } catch (error) {
      console.error(error)
    }
  }

 return (
  <>
   <div
  style={{
    // marginLeft: "18.5rem",
    // transition: "margin-left 0.3s ease",
   // backgroundColor: "#efecff", // full width background
    // minHeight: "100vh",         // covers the full height
    // width: "100%",               // full width coverage
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    // padding: "60px 50px",          // spacing from top
    // boxSizing: "border-box",
    // overflowY: "auto",
    // marginTop: "-180px"
     
        background: '#efecff', 
        width: 'auto',
        minHeight: "92vh",
        // minHeight: '100vh',  
        transition: "margin-left 0.3s ease",
        overflowY: "auto",  
        msOverflowStyle: "none",       // IE & Edge
        scrollbarWidth: "none",  
        padding: 40, 
        fontFamily: 'Inter, sans-serif'
  }}
>

    <div
  style={{
    // display: "grid",
    // justifyContent: "center",
    // boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    // borderRadius: "20px",
    // // width: "75vw",
    // backgroundColor: "white",
    // padding: "20px 20px",
    // // maxHeight: "85vh", // reduced height
    // overflow: "auto"
       marginTop: "40px",
        //   marginLeft: "20px",
        //   width: "100%",
        //  maxWidth: "1130px",
        justifyContent:'center',
        alignItems:'center',
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          padding: "20px",
  }}
>

        <h5 style={{ fontWeight: "bold", textAlign: "left", marginBottom: "20px", marginLeft: "10px", color: "black" }}>
          <img src={"/Bill-Files-Details-32.png"} alt="Project Icon" style={{ marginRight: "10px", width: 28, height: 28 }} />
          Bill Files Details
        </h5>
        <div style={{ overflowX: "auto", width: "100%", borderRadius: "20px" }}>
          <table
            style={{
              backgroundColor: "white",
              width: "100%",
              // borderRadius: "10px",
              // borderCollapse: "collapse",
              overflow: "hidden",
              minWidth: "70vw",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#2ea4e7",
                  color: "white",
                  height: "3rem",
                  fontSize: "16px",
                  textAlign: "center",
                }}
              >
                <th style={{ padding: "10px" }}>Sr.no.</th>
                <th style={{ padding: "10px" }}>File Name</th>
                <th style={{ padding: "10px" }}>Upload Date</th>
                <th style={{ padding: "10px" }}>Bill Processed by</th>
              </tr>
            </thead>
            <tbody>
              {currentBills &&
                currentBills.map((e, index) => {
                  return (
                    <tr
                      key={index}
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        textAlign: "center",
                        backgroundColor: index % 2 === 0 ? "#f4f7fe" : "white",
                      }}
                    >
                      <td style={{ padding: "10px" }}>
                        
                        {index + 1}
                      </td>
                      <td style={{ padding: "10px" }}>
                        <img
                         src={"/txt-32.png"}
                          alt="File Icon"
                          style={{ marginRight: "2px", height: 20, width: 20 }}
                        />
                        <a
                          href={`${apiurl}/UploadedBillsFiles/${e.FileName}`}
                          target="_blank"
                          style={{ color: "#0071bc",  textDecoration: "none" }}
                        >
                          {e.FileName}
                        </a>
                      </td>
                      <td style={{ padding: "10px" }}>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <img
                           src={"/Time-32.png"}
                            alt="Clock Icon"
                            style={{ marginRight: "5px" ,height: 20, width: 20}}
                          />
                          {new Date(e.CreatedOn)
                            .toLocaleString("en-GB", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: false,
                            })
                            .replace(",", "")}
                        </span>
                      </td>
                      <td style={{ padding: "10px" }}>{e.CreatedBy}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "20px",
  }}
>
  <p style={{ fontSize: "18px", color: "black" }}>
    Showing {currentBills.length} of {refundfiles.length} entries
  </p>

  <div style={{ display: "flex",  }}>
    <button
      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      style={{
        padding: "8px 10px",
        fontSize: "18px",
        fontWeight: "bold",
        width: "2rem",
        height: "2.5rem",
        
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: '0.2s ease-in-out',
        // borderRadius: "5px",
        cursor: "pointer",
        backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
        color: "#044c92",
        border: "1px solid #cccccc",
      }}
    >
      &laquo;
    </button>

    <button
      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      style={{
        padding: "8px 15px",
        // borderRadius: "5px",
        fontSize: "18px",
        fontWeight: "bold",
        width: "2rem",
        height: "2.5rem",
        
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: '0.2s ease-in-out',
        cursor: "pointer",
        backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
        color: "#044c92",
       border: "1px solid #cccccc",
      }}
    >
      &lt;
    </button>

    <span
      style={{
        padding: "8px 15px",
        // borderRadius: "5px",
        fontSize: "18px",
        fontWeight: "bold",
        width: "2rem",
        height: "2.5rem",
        
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: '0.2s ease-in-out',
          background: 'linear-gradient(to bottom, #044c92 , #0071bc , #022f5a )',
        color: "#ffffff",
        
        border: "1px solid #cccccc",
      }}
    >
      {currentPage}
    </span>

    <button
      onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
      disabled={currentPage === totalPages}
      style={{
        padding: "8px 15px",
        // borderRadius: "5px",
        fontSize: "18px",
        fontWeight: "bold",
        cursor: "pointer",
        width: "2rem",
        height: "2.5rem",
        
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: '0.2s ease-in-out',
        backgroundColor: currentPage === totalPages ? "#ffffff" : "#e5f4fb",
       color: "#044c92",
       border: "1px solid #cccccc",
      }}
    >
       &gt;
    </button>

    <button
      onClick={() => setCurrentPage(totalPages)}
      disabled={currentPage === totalPages}
      style={{
        padding: "8px 15px",
        // borderRadius: "5px",
        fontSize: "18px",
        fontWeight: "bold",
        cursor: "pointer",
        width: "2rem",
        height: "2.5rem",
        
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: '0.2s ease-in-out',
        backgroundColor: currentPage === totalPages ? "#ffffff" : "#e5f4fb",
        color: "#044c92",
        border: "1px solid #cccccc",
      }}
    >
     &raquo;
    </button>
  </div>
</div>
      </div>
    </div>
  </>
);
};

export default BillFiles;
